module.exports = __webpack_public_path__ + "img/login-eloyalfaro.664594d5.svg";